import type {
  SortKeys,
  SurveyListItem,
  SurveysGroupedByProjectCategory,
} from 'src/types/survey';

export const sortSurveyBy = (
  a: SurveyListItem[keyof SurveyListItem],
  b: SurveyListItem[keyof SurveyListItem],
) => {
  if (typeof a === 'string' && typeof b === 'string') {
    return (a as string).localeCompare(b as string);
  }
  return (a || false) < (b || false) ? 1 : a === b ? 0 : -1;
};

export const getSortedSurveys = (
  sortValue: SortKeys | null,
  surveys: SurveyListItem[],
) => {
  if (!sortValue || !surveys.length) return surveys;

  if (sortValue.startsWith('-')) {
    const key = sortValue.slice(1) as keyof SurveyListItem;
    if (!Object.hasOwn(surveys[0], key)) return surveys;
    return surveys.sort((a: SurveyListItem, b: SurveyListItem) =>
      sortSurveyBy(b[key], a[key]),
    );
  }

  const key = sortValue as keyof SurveyListItem;
  if (!Object.hasOwn(surveys[0], key)) return surveys;
  return surveys.sort((a: SurveyListItem, b: SurveyListItem) =>
    sortSurveyBy(a[key], b[key]),
  );
};

export const groupSurveysByProjectCategory = (
  surveys: SurveyListItem[],
): SurveysGroupedByProjectCategory =>
  surveys.reduce((acc: SurveysGroupedByProjectCategory, survey) => {
    const projectCategoryId = survey.projectCategoryId ?? 0;
    let projectData;
    if (projectCategoryId in acc) {
      projectData = {
        ...acc[projectCategoryId],
        surveys: [...acc[projectCategoryId].surveys, survey],
      };
    } else {
      projectData = {
        projectCategoryName: survey.projectCategoryName,
        surveys: [survey],
      };
    }
    return { ...acc, [projectCategoryId]: projectData };
  }, {});
